import styled from '@emotion/styled';

export const Wrapper = styled.div`
  font: 0.875rem/1.5rem;
  border-bottom: 0.063rem solid ${({ theme }) => theme.color.light1};
  padding-bottom: 1rem;
`;
